module.exports = __webpack_public_path__ + "static/img/yiLiNian.f582425.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/yiLiNian.png
// module id = U+6a
// module chunks = 0